import { Benevole } from "@/models";
import BenevoleService from "@/services/benevole.service";
import { Module, VuexModule, Action, Mutation } from "vuex-class-modules";

/** Holds the volunteer list and the currently-loaded single volunteer (detail view). */
@Module
export class Benevoles extends VuexModule {
  private _benevoles: Benevole[] | null = null;
  private _benevole: Benevole | null = null;

  @Mutation
  private setBenevoles(benevoles: Benevole[]) {
    this._benevoles = benevoles;
  }

  @Mutation
  private setBenevole(benevole: Benevole) {
    this._benevole = benevole;
  }

  /** Loads the full volunteer list into the store. */
  @Action
  public async benevoles(): Promise<void> {
    const benevoles = await await BenevoleService.benevoles();
    this.setBenevoles(benevoles);
  }

  /** Loads a single volunteer's detail into the store. */
  @Action
  public async benevole(id: string): Promise<void> {
    const benevole = await await BenevoleService.benevole(id);
    this.setBenevole(benevole);
  }

  /** The full volunteer list, or `null` if not yet loaded. */
  get getBenevoles(): Benevole[] | null {
    return this._benevoles;
  }

  /** The currently-loaded volunteer detail, or `null` if none loaded. */
  get getBenevole(): Benevole | null {
    return this._benevole;
  }
}
